// extracted by mini-css-extract-plugin
export default {"button":"PrescreenSubmissionCardButtons_button__Tl5a4","buttons":"PrescreenSubmissionCardButtons_buttons__RNqoc"};